import { useTranslation } from "react-i18next";
import React from "react";
import { BookingTypeEnum } from "@bn/api/apiv1";
import { Badge, BadgeVariant } from "@components/Badge";

export const BookingType = ({ type }: { type?: BookingTypeEnum }) => {
  const { t } = useTranslation();
  const map: Record<BookingTypeEnum, BadgeVariant> = {
    buy: "success",
    book_in: "success",
    sell: "info",
    book_out: "info",
    dividend: "secondary",
    split: "secondary",
    reverse_split: "secondary",
    switch: "secondary",
    retained_dividend: "secondary",
    purchase_right: "secondary",
    carve_out: "secondary",
    pre_tax_allowance: "secondary",
    cap_gains_tax: "secondary",
    cap_gains_tax_refund: "secondary",
    fees: "secondary",
  };

  if (!type) {
    return null;
  }

  return <Badge variant={map[type]}>{t(`bookingTypes.${type}`)}</Badge>;
};
